import { DISTRIBUTION_URL } from "../../../services/common-urls";
import { clientName, JSON_STRING, MHTTPCL, createHttpGetOptions } from "../../../services/http/http-client";


export const ReportService = {
    getReportData: () =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "home",
            output: "json",
        }),
    getReportFilteredData: () =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "report_filter_data",
            output: "json",
        }),
    getLabels: ({ str }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "get_labels",
            output: "json",
            str,

        }),
    getFilterSelectionData: () =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "filter_selection_modal",
            filter_empty: 1,
            output: "json",


        }),


    getReleases: ({ str }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "get_releases",
            output: "json",
            str,


        }),


    getProducts: ({ str }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "get_products",
            output: "json",
            str,
        }),

    getTracks: ({ str }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "get_tracks",
            output: "json",
            str,
        }),
    getAccounts: ({ str }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "get_accounts",
            str,
            output: "json",
        }),

    getShops: ({ str }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "get_shops",
            str,
            output: "json",
        }),

    getCountries: ({ str }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "get_countries",
            str,
            output: "json",
        }),
    getFormats: ({ str }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "get_formats",
            str,
            output: "json",
        }),
    getSelectionModatData: () =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "filter_selection_modal",
            output: "json",
        }),
    getSummarizedReports: ({ filter,
        chapter,
        group_by,
        top_ten, token }) =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "summarized_report_v1",
            filter: JSON.stringify(filter),
            chapter,
            group_by,
            top_ten,
            output: "json",
            token
        }),

    checkReportStatus: (token) =>
        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            output: "json",
            action: 'check_report_status',
            token: token
        }),
    getReportResult: (token) =>
        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: 'summarized_report_v1_html',
            output: "json",
            token: token
        }),
    getRawSalesReports: ({ filter,
        token }) =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "sales_report",
            filter: JSON.stringify(filter),

            output: "json",
            end_tag: token
        }),

    exportReportData: (token) => MHTTPCL.getFinalURL(DISTRIBUTION_URL, {
        section: "reports",
        action: "summary_report_xlsx",
        token: token,
        output: JSON_STRING
    }),
    exportRawSalesReportData: (token) => MHTTPCL.getFinalURL(DISTRIBUTION_URL, {
        section: "reports",
        action: "download_sales_report",
        token: token,
        output: JSON_STRING
    }),
    getStockReportModalData: () =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "stock_report_modal",
            output: "json",

        }),
    getStockReportExportData: ({ format_group,label_id, account_id, end_date, main_account }) =>

        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "stock_report",
            format_group,
            label_id,
            account_id,
            end_date,
            main_account,
            output: "json",

        }, createHttpGetOptions({ responseType: 'blob' })),
    getLabelReportModalData: () =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "label_report_modal",
            output: "json",

        }),
    getLabelReportExportData: ({ label_id, report_type, start_date, end_date, account }) =>

        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "label_report",
            label_id,
            report_type,
            start_date,
            end_date,
            account,
            output: "json",

        }, createHttpGetOptions({ responseType: 'blob' })),
    getReleaseReportModalData: () =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "release_report_modal",
            output: "json",

        }),
    getReleaseReportExportData: ({ label_id, start_date, end_date }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "filter_release_report",
            label_id,
            start_date,
            end_date,
            output: "json",

        }, createHttpGetOptions({ responseType: 'blob' })),
    getProductReportModalData: () =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "catalog_report_modal",
            output: "json",

        }),

    getProductReportExportData: ({ label_id, start_date, end_date, format_id, channel, price_list_id, category_1, category_2, stock_location_id }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "filter_catalog_report",
            label_id,
            start_date,
            end_date,
            format_id,
            channel,
            price_list_id,
            category_1,
            category_2,
            stock_location_id,
            output: "json",

        }, createHttpGetOptions({ responseType: 'blob' })),
    getOpenOrderReportModalData: () =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "open_order_report_modal",
            output: "json",

        }),
    getOpenOrderAccountReportExportData: ({ label_id, account_id, start_date, backorder, open_order, manufacturing }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "open_order_account_report",
            label_id,
            account_id,
            start_date,
            backorder,
            open_order,
            manufacturing,
            output: "json",

        }, createHttpGetOptions({ responseType: 'blob' })),
    getOpenOrderSummarizedReportExportData: ({ label_id, account_id, start_date, backorder, open_order, manufacturing }) =>
        MHTTPCL.get(DISTRIBUTION_URL, {
            section: "reports",
            action: "open_order_summarized_report",
            label_id,
            account_id,
            start_date,
            backorder,
            open_order,
            manufacturing,
            output: "json",

        }, createHttpGetOptions({ responseType: 'blob' })),

    getShopManagementReportModalData: () =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "clean_shop_names",
            output: "json",

        }),
    getCostReportModalData: () =>

        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "cost_export_modal",
            output: "json",

        }),

    getCostReportExportData: ({ start_date, end_date, cost_group_ids }) =>
        MHTTPCL.getFinalURL(DISTRIBUTION_URL, {
            section: "reports",
            action: "cost_export_file",
            start_date,
            end_date,
            cost_group_ids: JSON.stringify(cost_group_ids),
            labels: [],
            releases: [],
            products: [],
            output: "json",

        }),

    updateShopNames: () =>
        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "update_shop_names",
            output: "json",

        }),
    checkShopNames: ({ relation_id, shop }) =>
        MHTTPCL.post(DISTRIBUTION_URL, {
            section: "reports",
            action: "check_shop_name",
            relation_id,
            shop,
            output: "json",

        }),
    modify: ({ kVal, name, value }) =>
        MHTTPCL.post('/modify.pl', {
            kVal,
            name,
            value,
            table: 'l_relations',
            output: "json",

        }),



};



